export const environment = {
  production: false,
  apiUrl: 'https://api-uat.devducksolutions.com',
};
